import { cornType } from '@eigtech/shared-corn';
export const summarizerServiceCorn = (eventName) => cornType('summarizer', eventName);
export const summarizerServiceCornSchema = summarizerServiceCorn();
